<template>
  <div class="compass">
            <svg
                id="compass"
                data-name="compass"
                viewBox="0 0 419.6 432.4"
                :style="`transform: rotate(${rotate}deg);`"
                fill="#425B91"
            >
            <linearGradient
                id="gradient"
                x1="0"
                y1="0"
                x2="800"
                y2="0"
                gradientUnits="userSpaceOnUse"
            >
                <stop offset="0" stop-color="#6299d8" />

                <stop offset="0.14285714285714285" stop-color="#5e91cf" />

                <stop offset="0.2857142857142857" stop-color="#5a89c6" />

                <stop offset="0.42857142857142855" stop-color="#5680bd" />

                <stop offset="0.5714285714285714" stop-color="#5278b4" />

                <stop offset="0.7142857142857142" stop-color="#4d70ab" />

                <stop offset="0.8571428571428571" stop-color="#4969a2" />

                <stop offset="1" stop-color="#456199" />
            </linearGradient>
            <path
                d="M419.3,223.4H400.14A183,183,0,0,0,277.23,55.16,6.5,6.5,0,
0,0,273,67.44a170,170,0,0,1,114.16,156h-16a6.5,6.5,0,0,0,0,13H387c-4.29,87.65-75.3,
158-163.19,161.36V384.5a6.5,6.5,0,0,0-13,0v13.26C122.91,394.44,51.9,324.05,47.61,
236.4H60.9a6.5,6.5,0,1,0,0-13H47.47a170,170,0,0,1,114.16-156,6.5,6.5,0,1,0-4.26-12.28A183,
183,0,0,0,34.46,223.4H12.7a6.5,6.5,0,1,0,0,13H34.6c4.31,94.81,81.14,171,176.2,
174.37V432.7a6.5,6.5,0,0,0,13,0V410.77c95.06-3.34,171.89-79.56,176.2-174.37h19.3a6.5,6.5,0,
0,0,0-13Z"
                transform="translate(-6.2 -6.8)"
            />
            <path
                d="M231,185.8v36.73l-28.76-41a7.5,7.5,0,0,0-13.64,4.3v60.5a7.5,
7.5,0,0,0,15,0V209.57l28.76,41a7.48,7.48,0,0,0,6.14,3.2,7.39,
7.39,0,0,0,2.26-.35A7.49,7.49,0,0,0,246,246.3V185.8a7.5,7.5,0,0,0-15,0Z"
                transform="translate(-6.2 -6.8)"
            />
            <path
                d="M212.74,9.79a5.42,5.42,0,0,0-.4.71s0,.05,0,.08l-60.1,130.2a6.49,6.49,0,0,0,5.9,9.22H276.39a6.11,6.11,0,0,0,.86-.06,6.53,6.53,0,0,0,.77-.14l.13-.05c.22-.06.43-.12.64-.2l.33-.16.4-.19c.13-.07.25-.15.37-.23l.31-.2c.12-.08.23-.18.34-.27l.3-.25.27-.29c.1-.11.21-.21.3-.32l.22-.3.22-.3.06-.1a.35.35,0,0,0,0-.08,3.55,3.55,0,0,0,.23-.43.54.54,0,0,0,.07-.13,6.76,6.76,0,0,0,.29-.69c0-.05,0-.1,0-.15s.11-.38.16-.58a1.29,1.29,0,0,1,0-.19,5.54,5.54,0,0,0,.07-.57,1.1,1.1,0,0,0,0-.18,5.63,5.63,0,0,0,0-.71v0a5.82,5.82,0,0,0-.08-.73,1.55,1.55,0,0,0,0-.21,4.37,4.37,0,0,0-.12-.52c0-.07,0-.15-.07-.23s-.13-.37-.2-.55a1.17,1.17,0,0,0-.05-.11l-58.2-130.2a.3.3,0,0,0,0-.08,5.19,5.19,0,0,0-.35-.66l-.09-.14a6.26,6.26,0,0,0-.49-.66.69.69,0,0,0-.11-.13,5.44,5.44,0,0,0-.48-.48l-.14-.13a7.37,7.37,0,0,0-.65-.49.53.53,0,0,0-.1-.06,5.79,5.79,0,0,0-.64-.36l-.15-.07a5.52,5.52,0,0,0-.8-.31h0a5.32,5.32,0,0,0-.79-.18l-.2,0a4.9,4.9,0,0,0-.77-.06h-.11a8.29,8.29,0,0,0-.87.06h-.05A6.47,6.47,0,0,0,213.34,9l0,0a5.48,5.48,0,0,0-.55.72ZM184.29,137l34-21.08L253.09,137h-68.8m40.41-32.37V43.77L262,127.19Zm-13,.05-40,24.82,40-86.61Z"
                transform="translate(-6.2 -6.8)"
            />
            </svg>
  </div>
</template>

<script>
export default {
  name: "Compass",
  props: {
    rotate: {
      type: [Number, String],
      default: 0,
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/styles/Compass.scss';
</style>
